module.exports = __webpack_public_path__ + "img/maestro.637dc8ec.svg";